export enum NutriScore {
    A = 'NUTRISCORE_A',
    B = 'NUTRISCORE_B',
    C = 'NUTRISCORE_C',
    D = 'NUTRISCORE_D',
    E = 'NUTRISCORE_E',
}
